<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import Modal from '../Modal.svelte';
    import Button from '../Button.svelte';
    import {object, string} from 'yup';
    import {validateForm} from '../Form/utils.js';
    import Errors from '../Errors.svelte';
    import {get, post} from '../../utils.js';
    import {sgettext} from '../../i18n.js';

    export let id = 'searchEmailGroupForm';
    
    let title = sgettext('$$SEARCH_USERS_1$$');
    let searchQuery = "";
    let emailGroups = null;
    let removeUserFrom = [];
    let schema = object().shape({
        user_email: string().email().required(),
    });
    let formErrors = [];

    $: searchQueryFormatted = searchQuery ? searchQuery.trim().toLowerCase() : "";
    $: searchUrl = `${PATH_PREFIX}/sw/administration/user-email-groups/?search=${searchQueryFormatted}`
    $: removeUrl = `${PATH_PREFIX}/sw/administration/user-email-groups/`

    $: if (searchQuery || searchQuery == "") {
        // when searchQuery changes or is made an empty string, emailGroups and removeUserFrom are reset
        emailGroups = null;
        removeUserFrom = [];
        formErrors = "";
    }

    async function isEmailValid() {
        await validateForm(schema, {user_email: searchQueryFormatted});
        if (searchQueryFormatted.split("@")[1].toLowerCase() !== "bhp.com") {
            formErrors = sgettext('$$VALID_EMAIL_ADDRESSES_END_BHPCOM$$');
            return false;
        }
        return true;
    }

    async function handleRemove(emailGroupId) {
        removeUserFrom = [...removeUserFrom, emailGroupId]
        emailGroups = emailGroups.filter(eg => eg.id != emailGroupId);
    }

    function cancelModal() {
        jQuery(`#${id}`).modal('hide');
        searchQuery = "";
        removeUserFrom = [];
        formErrors = "";
    }

    async function handleSaveChanges() {
        try {
            let isBhpEmail = await isEmailValid();
            if (!isBhpEmail) return;

            formErrors = ""

            const response = await post(removeUrl, {
                search_phrase: searchQueryFormatted,
                email_groups: removeUserFrom,
            });

            if (response.ok) {
                cancelModal();
                location.reload();
            }
            else {
                if (response.hasOwnProperty('error')) {
                    formErrors = err.error;
                }
            }
        }
        catch(err) {
            formErrors = sgettext('$$SOMETHING_WENT_WRONG_REMOVING_USER_MWCS$$');
        }
        finally {
            searchQuery = null;
            removeUserFrom = [];
        } 
    }

    async function handleSearch() {
        emailGroups = null;
        try {
            let isBhpEmail = await isEmailValid();
            if (!isBhpEmail) return;
            
            formErrors = ""

            const response = await get(searchUrl);
            if (response.ok) {
                const res = await response.json()
                emailGroups = res;
            }
            else {
                const error = await response.json();
                if (error.hasOwnProperty('error')) {
                    formErrors = error;
                }
            }
        }
        catch(err) {
            if(err.inner){
                err.inner.forEach(er => {
                    formErrors = sgettext('$$PLEASE_ENTER_VALID_EMAIL_ADDRESS$$');
                });
            }        
        }
    }
</script>

<Modal {id} {title} large={true} backdrop={'static'} onCancel={cancelModal}>
  <div slot="body">
    {#if formErrors && formErrors.length > 0}
      <Errors errors={formErrors} />
    {/if}
    <form on:submit|preventDefault={handleSearch}>
      <div class="form-group">
        <label for="searchUserEmail"
          >{sgettext('$$USER_EMAIL$$')} <span style="color:red;">*</span></label
        >
        <input
          id="searchUserEmail"
          class="form-control"
          type="text"
          bind:value={searchQuery}
        />
      </div>
    </form>

    {#if emailGroups && emailGroups.length > 0}
      <hr />
      <p class="mb-4">
        <b>{sgettext('$$MAIN_WORK_CENTRES_USER_CONFIGURED_1$$')}</b>
      </p>
      {#each emailGroups as eg, index (eg.id)}
        <div class="d-flex justify-content-between pl-1 pr-3">
          <p>
            {eg.plant.name}
            {eg.plant.description ? ' - ' + eg.plant.description : ''} | {eg
              .work_centre.name}
            {eg.work_centre.description
              ? ' - ' + eg.work_centre.description
              : ''}
          </p>
          <p>
            <i
              class="fa fa-trash text-primary"
              on:click={() => handleRemove(eg.id)}
            />
          </p>
        </div>
        {#if index < emailGroups.length - 1}<hr class="mt-0" />{/if}
      {/each}
    {:else if emailGroups && emailGroups.length == 0 && searchQuery}
      <hr />
      <p class="text-secondary text-center">
        <b><i>{sgettext('$$USER_NOT_CONFIGURED_MWC$$')}</i></b>
      </p>
    {/if}
  </div>

  <div slot="footer">
    <Button name={sgettext('$$CANCEL$$')} on:click={cancelModal} type="secondary" />
    {#if removeUserFrom.length > 0}
      <Button
        name={sgettext('$$SAVE_CHANGES_1$$')}
        on:click={handleSaveChanges}
        disabled={searchQuery && searchQuery.length == 0}
      />
    {:else}
      <Button
        name={sgettext('$$SEARCH$$')}
        on:click={handleSearch}
        disabled={searchQuery && searchQuery.length == 0}
      />
    {/if}
  </div>
</Modal>

<style></style>
